import { Injectable, inject } from '@angular/core';
import { BaseQueryRepository } from '@okcargo-apps/services';
import { AccountResponse, FindAccountQuery, FindAccountQueryHandler } from '@okcargo/query-processor';

@Injectable({ providedIn: 'root' })
export class AccountQueryService {
  private readonly queryRepository = inject(BaseQueryRepository);

  private readonly findAccountQueryHandler = new FindAccountQueryHandler(this.queryRepository);

  public findAccount(): Promise<AccountResponse> {
    const query = {} as FindAccountQuery;
    return this.findAccountQueryHandler.handle(query);
  }
}
